// extracted by mini-css-extract-plugin
export var phone = "_46-0";